<template>
  <div class="container-pay" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop: ${barHeight}px; backgroundColor: #F9F9FB`">
      <van-nav-bar class="van-bar" left-trangle @click-left="goBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.commonM.k368') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <div class="pay">
        <div class="money-block">
          <img class="moneys" :src="getMatchImg('coin')" alt="" />
          <div class="amount">{{ myPlus(amount, presentAmount) }}</div>
          <div v-if="presentAmount > 0" class="origin-amount">
            <div class="old-amount">{{ amount }}</div>
            <div class="extra-amount">+{{ presentAmount }}</div>
          </div>
        </div>
        <div class="pay-other">
          <template v-for="(item, index) in presentPropList">
            <div v-if="item.propType == 1" class="dis-item">
              <img :src="getMatchImg('chat-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 2" class="dis-item">
              <img :src="getMatchImg('video-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 4" class="dis-item">
              <img :src="getMatchImg('vip')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 6" class="dis-item">
              <img :src="getMatchImg('call-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 9" class="dis-item">
              <img :src="getMatchImg('coupon')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 15" class="dis-item">
              <img :src="getMatchImg('super-chat-pass')" />
              x{{ item.number }}
            </div>
          </template>
        </div>
        <div class="tips-one">{{ $t('lang.commonM.k369') }}</div>
      </div>

      <!-- todo 样式先写，接口还未支持 -->
      <!-- <div class="pay-card">
        <div class="card-tag">New subscriber offer</div>
        <div class="card-main">
          <div class="card-amount">TRY 199</div>
          <div class="card-discount">
            <div>TRY 300</div>
            <div>For 1-Month VIP</div>
          </div>
        </div>
        <div class="card-gifts">
          <div class="gift-item">
            <img :src="getMatchImg('vip')" />
            &nbsp;
            <i>x20 Match Pass/day</i>
          </div>

          <div class="gift-item">
            <img :src="getMatchImg('vip')" />
            &nbsp;
            <i>x20 Match Pass/day</i>
          </div>

          <div class="gift-item">
            <img :src="getMatchImg('vip')" />
            &nbsp;
            <i>x20 Match Pass/day</i>
          </div>
        </div>
      </div> -->

      <!-- Coupons -->
      <div class="block-title">
        <div>{{ $t('lang.commonM.k370') }}</div>
        <div class="looping-container">
          <div class="looping-text">{{ $t('lang.commonM.k387') }}</div>
        </div>
      </div>

      <div class="coupons-block">
        <!-- 优惠券入口 -->
        <div class="coupon-item" @click="handleClickCouponEnter">
          <!-- 有可用优惠券 -->
          <template v-if="selectedCoupon">
            <div class="coupon-check checked"></div>
            <div class="coupon-con">
              <img class="coupon" :src="getMatchImg('coupon')" />
              <div class="coupon-info">
                <MyPLabel class="info-main" :str="selectedCoupon.descV2" :customClass="{ coin: 'pay-coin-icon' }" />
              </div>
            </div>
          </template>
          <!-- 无可用优惠券 -->
          <template v-else>
            <div class="coupon-check not-checked"></div>
            <div class="coupon-con no-valid-coupon">
              <img class="coupon" :src="getMatchImg('coupon-off')" />
              <div class="coupon-info">
                <span class="info-main">{{ $t('lang.intimate.noValidCou') }}</span>
              </div>
            </div>
          </template>
          <div v-if="validCouponList && validCouponList.length" class="coupon-arrow" :class="[showCoupons ? 'arrow-up' : '']"></div>
        </div>
        <!-- 优惠券列表 -->
        <div v-if="showCoupons" class="coupon-scroll">
          <div class="coupon-item" v-for="(item, index) in validCouponList" :key="item.couponRecordId" @click="handleSelectCoupon(item)">
            <div v-if="selectedCoupon && item.couponRecordId === selectedCoupon.couponRecordId" class="coupon-check checked"></div>
            <div v-else class="coupon-check not-checked"></div>
            <!-- 可用 -->
            <div v-if="item.canUse === true" class="coupon-con">
              <img class="coupon" :src="getMatchImg('coupon')" />
              <div class="coupon-info">
                <MyPLabel class="info-main" :str="item.descV2" :customClass="{ coin: 'pay-coin-icon' }" />
              </div>
            </div>
            <!-- 无用 -->
            <div v-else class="coupon-con no-valid-coupon">
              <img class="coupon" :src="getMatchImg('coupon-off')" />
              <div class="coupon-info">
                <MyPLabel class="info-main" :str="item.descV2" :customClass="{ coin: 'pay-coin-icon' }" />
                <span class="info-tips">This item is not supported</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Methods -->
      <div class="block-title">
        <div>{{ $t('lang.commonM.k371') }}</div>
        <!-- todo 还未支持 -->
        <!-- <div>why there are different methods？</div> -->
      </div>
      <template v-for="(item, index) in payList">
        <div
          v-if="index <= beforeOriginPayIndex && item.priority <= currentPayTypeLevel"
          :key="index"
          :class="['method-item', item.ifBestPrice === true ? 'best-type' : '', index === selectedIndex ? 'method-on' : '']"
          @click.prevent="handleSelectPay(item, index)"
        >
          <div class="method-con">
            <div class="method-check" :class="[index === selectedIndex ? 'checked' : 'not-checked']"></div>
            <div class="method-img"><img :src="item.icon | imgPath" alt="" /></div>
            <div class="method-name" v-if="item.icon">
              <div class="method-info">
                <span class="name">{{ item.name }}</span>
                &nbsp;
                <div v-if="item.label" class="discount">{{ item.label }}</div>
              </div>
              <div class="rate">{{ item.currency }}&nbsp;{{ handleDiv100(item.price) }}</div>
            </div>
          </div>
          <MyPLabel v-if="item.ifBestPrice === true" class="method-tips" :str="$t('lang.commonM.k385')" :customClass="{ coin: 'pay-coin-icon' }" />
        </div>
      </template>

      <div
        v-if="googlePrice"
        :class="['method-item', selectedIndex === 9999 ? 'best-type' : '']"
        @click.prevent="handleSelectPay({ currency: googlePriceCurrency, price: myTimes(googlePrice, 100) }, 9999)"
      >
        <div class="method-con">
          <div class="method-check" :class="[selectedIndex === 9999 ? 'checked' : 'not-checked']"></div>
          <div class="method-img">
            <img v-if="env.isIOS" src="@/assets/packageAssets/common/apple_pay.png" alt="" />
            <img v-else src="@/assets/packageAssets/common/google.png" alt="" />
          </div>
          <div class="method-name">
            <div class="method-info">
              <span class="name">{{ env.isIOS ? 'Apple Pay' : 'Google Pay' }}</span>
            </div>
            <div class="rate">{{ googlePriceCurrency }} {{ googlePrice }}</div>
          </div>
        </div>
      </div>

      <template v-for="(item, index) in payList">
        <div
          v-if="index > beforeOriginPayIndex && item.priority <= currentPayTypeLevel"
          :key="index"
          :class="['method-item', item.ifBestPrice === true ? 'best-type' : '', index === selectedIndex ? 'method-on' : '']"
          @click.prevent="handleSelectPay(item, index)"
        >
          <div class="method-con">
            <div class="method-check" :class="[index === selectedIndex ? 'checked' : 'not-checked']"></div>
            <div class="method-img"><img :src="item.icon | imgPath" alt="" /></div>
            <div class="method-name" v-if="item.icon">
              <div class="method-info">
                <span class="name">{{ item.name }}</span>
                &nbsp;
                <div v-if="item.label" class="discount">{{ item.label }}</div>
              </div>
              <div class="rate">{{ item.currency }} {{ handleDiv100(item.price) }}</div>
            </div>
          </div>
          <MyPLabel v-if="item.ifBestPrice === true" class="method-tips" :str="$t('lang.commonM.k385')" :customClass="{ coin: 'pay-coin-icon' }" />
        </div>
      </template>

      <div v-if="showMore" class="method-more">
        <div class="trangle" :class="{ 'trangle-down': currentPayTypeLevel !== lastPayTypeLevel }" @click="showMorePay"></div>
      </div>

      <!-- 底部栏占位用 -->
      <div style="width: 100%; height: 100px"></div>

      <div class="submit-btn-block">
        <!-- prettier-ignore -->
        <div class="submit-btn" @click="handleClickPay">
          {{ $t('lang.host.get')}} {{ myPlus(amount, presentAmount) }} <img :src="getMatchImg('coin')" />
          <template v-if="selectedItem">({{selectedItem.currency}}&nbsp;{{handleDiv100(selectedItem.price)}})</template> 
          <van-loading v-if="loadingShow" type="spinner" color="#ffffff" class="pay-loading" size="20px" />
        </div>
        <div :style="{ height: `${bottomBarHeight || 30}px` }"></div>
      </div>
    </div>

    <!-- 支付结果弹窗 -->
    <PayResult :showDiaC="showResultDia" :oneShow="true" :title="payResultText" />
  </div>
</template>

<script>
// 多包样式
import { pageCssVars } from '@/views/P1_Boys/PayNext/z-style-cfg.js'

import { apiFetchPayList, apiFetchShopOrder } from '@/api/imee'
import { mixin } from './base.mixin.js'

import _debounce from 'lodash/debounce'

import PayResult from '@/components/CConfirm/PayResult.vue'

export default {
  mixins: [pageCssVars, mixin],
  components: { PayResult },
  data() {
    const query = this.$route.query
    return {
      // 产品信息
      gid: query.gid || '4',
      productId: null,

      // 优惠信息
      amount: 0,
      presentAmount: 0,
      presentPropList: [],

      // 方式-三方
      lastUsedChannel: '',
      payList: [],
      selectedIndex: -1,
      selectedItem: null,

      // 方式-google/apple
      googlePrice: query.price || null,
      googlePriceCurrency: query.currency || null,

      // 控制参数-提示loading
      loadingShow: false,

      // 支付方式统计
      selectChannelIndex: -1
    }
  },
  methods: {
    fetchPayList() {
      const resolvePayList = (res, fromApi) => {
        this.productId = res.productId
        this.amount = res.amount || 0
        this.presentAmount = res.presentAmount || 0
        this.presentPropList = res.presentPropListV2 || []
        this.lastUsedChannel = res.lastUsedChannel
        this.payList = res.payChannelList || []

        fromApi && this.initCoupon()

        this.sortPayType()

        this.selectedBestPayType()

        this.initMore()
      }

      // 读取web localstorage缓存
      const localRes = window.localStorage.getItem(`payList${this.gid}`)
      if (localRes) {
        resolvePayList(JSON.parse(localRes))
      }

      apiFetchPayList({
        gid: this.gid,
        activityType: this.$route.query.activityType,
        tierId: this.$route.query.tierId || null,
        shopType: this.getShopType()
      }).then((res) => {
        if (res && res.payChannelList) {
          // 写入web localstorage缓存
          window.localStorage.setItem(`payList${this.gid}`, JSON.stringify(res))

          resolvePayList(res, true)
        }
      })
    },

    queryGoogleProductListCallback(res) {
      if (res) {
        try {
          const googlePayList = JSON.parse(res)
          const targetItem = googlePayList.find((item) => {
            return this.$route.query.productId == item.productId
          })
          if (targetItem) {
            this.googlePrice = targetItem.price
            this.googlePriceCurrency = targetItem.currencyCode
          }
        } catch (err) {
          console.log('try catch err:', err)
        }
      }
    },

    handleSelectPay(item, index) {
      this.selectedItem = item
      this.selectedIndex = index
    },

    handleClickPay() {
      if (this.selectedIndex > -1) {
        const tempKeys = Object.keys(this.selectedItem)
        // thirdpay
        if (tempKeys && tempKeys.length && this.selectedIndex !== 9999) {
          this.thirdPay(this.selectedItem)
        }
        // googlpay/applepay
        else {
          this.originPay()
        }
      }
    },

    thirdPay: _debounce(
      function (item) {
        let payChannelTotal = null
        if (this.payList && this.payList.length) {
          payChannelTotal = this.payList.length
        }
        let payChannelIndex = null
        if (this.selectChannelIndex != -1 && payChannelTotal !== null && payChannelTotal !== 0) {
          payChannelIndex = payChannelTotal - 1 - this.selectChannelIndex
        }
        if (this.googlePrice && this.googlePriceCurrency && payChannelTotal !== null && payChannelIndex !== null) {
          payChannelTotal = payChannelTotal + 1
          payChannelIndex = payChannelIndex + 1
        }

        let data = {
          tierId: this.$route.query.tierId || null,
          shopType: this.$route.query.shopType || null,
          gid: this.gid,
          payType: item.payType,
          scene: this.scene,
          thirdParam: this.thirdParam,
          payChannel: item.name,
          payChannelIndex: payChannelIndex,
          payChannelTotal: payChannelTotal
        }
        if (this.$route.query.videoChatScene) {
          data.videoChatScene = this.$route.query.videoChatScene
        }
        if (this.$route.query.activityType) {
          data.activityType = this.$route.query.activityType
        }
        if (this.selectedCoupon && this.scene != 'activity') {
          data.couponRecordId = this.selectedCoupon.couponRecordId
        }
        if (this.scene == 'activity') {
          data.shopType = 7
        }
        this.$client.addEvent('top_up', {
          Action: 'Click',
          APosition: 'payButton',
          productID: this.productId,
          goodtype: 'coin',
          from: 'cash',
          paymethod: item.name
        })

        this.loadingShow = true

        apiFetchShopOrder(data)
          .then((res) => {
            if (res) {
              this.initCoupon()

              this.order = res.credential && res.credential.wapUrl
              // 外部浏览器打开
              if (res.credential.openInExternalBrowser) {
                let url = 'iMee://open_web_outside?url=' + res.credential.wapUrl
                commandRouter.postMessage(url)
                if (['10', '18', '19'].includes(this.$route.query.activityType)) {
                  this.closeWeb()
                }
              }
              // webview打开
              else {
                if (this.order) {
                  this.$router.push({
                    path: '/pay-code',
                    query: {
                      url: this.order
                    }
                  })
                }
              }
            }
          })
          .catch(() => {})
          .finally(() => {
            this.loadingShow = false
          })
      },
      2000,
      {
        leading: true,
        trailing: false
      }
    ),

    // googlePay applePay 要客户端提供方法
    originPay() {
      // 从 h5 活动页进入，客户端不知道商品信息，不知道优惠券信息
      if (this.$route.query.useWebPay == '1') {
        const params = {
          gid: this.gid,
          productId: this.$route.query.productId,
          activityType: this.$route.query.activityType * 1,
          scene: this.$route.query.scene || '',
          tierId: this.$route.query.tierId || null,
          shopType: this.$route.query.shopType || null
        }
        // 使用优惠券
        if (this.maxCoupon) {
          params.couponRecordId = this.maxCoupon.couponRecordId
        }

        // echo
        if (this.packageName === 'echo') {
          nativePaymentFromWeb.postMessage(JSON.stringify(params))
        }
        // 其他包
        else {
          payGoogleFromWeb.postMessage(JSON.stringify(params))
        }

        // 调用支付后 关闭支付页面
        if (['10', '18', '19'].includes(this.$route.query.activityType)) {
          this.goPrevious()
        }
      }
      // 从客户端商品列表进入，客户端知道商品信息，不知道优惠券信息
      else {
        const params = {
          tierId: this.$route.query.tierId || null,
          shopType: this.$route.query.shopType || null
        }
        if (this.maxCoupon) {
          params.couponRecordId = this.maxCoupon.couponRecordId
        }

        // echo
        if (this.packageName === 'echo') {
          nativePayment.postMessage(JSON.stringify(params))
        }
        // 其他包
        else {
          payGoogle.postMessage(JSON.stringify(params))
        }
      }
    },

    refresh() {
      this.init()
    },

    init() {
      this.fetchPayList()
    }
  },
  created() {
    this.init()

    // 客户端回调-刷新
    window.refresh = this.refresh

    // 从客户端获取googlePay/applePay参数
    window.queryGoogleProductListCallback = this.queryGoogleProductListCallback
    if (!this.$route.query.price && this.$route.query.productId) {
      this.$client.googleProductList([this.$route.query.productId])
    }
  }
}
</script>
<style lang="scss" scoped>
.container-pay {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
  .main {
    padding: 0 18px 20px;
  }

  .pay {
    width: 100%;
    margin: 40px 0;
    .money-block {
      display: flex;
      align-items: center;
      justify-content: center;

      font-family: 'Inter Tight';

      .moneys {
        width: 30px;
        height: 30px;
      }
      .amount {
        color: var(--Fonts-Font-1, #333);
        font-size: 36px;
        font-weight: 600;
        line-height: 40px;
        margin: 0 6px;
      }

      .origin-amount {
        height: 36px;
        display: flex;
        align-items: flex-end;
        .old-amount {
          color: #333333;
          font-size: 15px;
          font-weight: 500;
          line-height: 18px;
        }
        .extra-amount {
          color: #ff4265;
          font-size: 15px;
          font-weight: 500;
          line-height: 18px;
        }
      }
    }
    .pay-other {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 16px;

      .dis-item {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        color: var(--Fonts-Font-1, #333);
        font-family: 'Inter Tight';
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;

        img {
          width: 20px;
        }
      }
    }
    .tips-one {
      width: 343px;
      margin: 8px auto 0;

      color: var(--Fonts-Font-3, #b2b2b2);
      font-family: 'Inter Tight';
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }
  }

  .pay-card {
    width: 343px;
    margin: 16px auto;
    padding: 16px;
    border-radius: 16px;
    background: linear-gradient(121deg, #0a4a46 -25.85%, rgba(10, 74, 70, 0) 57.36%), linear-gradient(180deg, #0b2e72 0%, rgba(11, 45, 116, 0) 100%), #4c1c73;
    .card-tag {
      display: inline-block;
      padding: 0 11px;
      color: #fff;
      -webkit-text-stroke-width: 0.5px;
      font-family: 'Inter Tight';
      font-size: 12px;
      font-style: italic;
      letter-spacing: 1px;
      font-weight: bold;
      line-height: 20px;
      background: var(--icon-tag-bg) top left / 100% auto no-repeat;
    }
    .card-main {
      margin-top: 24px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .card-amount {
        color: var(--System-Color-White, #fff);
        font-family: 'Inter Tight';
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 40px;
      }
      .card-discount {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        color: var(--System-Color-White-All, #fff);
        font-family: 'Inter Tight';
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
        div {
          &:nth-child(1) {
            text-decoration: line-through;
          }
          &:nth-child(2) {
            margin: 0 8px;
          }
        }
      }
    }
    .card-gifts {
      margin-top: 16px;
      overflow: hidden;
      .gift-item {
        float: left;
        width: 50%;
        display: flex;
        align-items: center;
        overflow: hidden;
        margin-top: 8px;

        color: var(--System-Color-White-All, rgba(255, 255, 255, 0.7));
        font-family: 'Inter Tight';
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
        img {
          width: 16px;
        }
      }
    }
  }

  .block-title {
    display: flex;
    align-items: flex-start;
    margin-top: 32px;
    div {
      &:nth-child(1) {
        width: 120px;
        color: var(--Fonts-Font-1, #333);
        font-family: 'Inter Tight';
        font-size: 17px;
        font-weight: 500;
        line-height: 20px;
      }
      &:nth-child(2) {
        width: 240px;
        color: var(--Fonts-Font-3, #b2b2b2);
        font-family: 'Inter Tight';
        font-size: 15px;
        font-weight: 400;
        line-height: 20px;
        text-align: left;
        white-space: nowrap;
      }
    }
    .looping-container {
      width: 240px;
      height: 20px;
      overflow: hidden;

      .looping-text {
        animation: slideLeft 9s linear infinite;
        width: fit-content;
        padding: 0 30px;
        color: var(--Fonts-Font-3, #b2b2b2);
        font-family: 'Inter Tight';
        font-size: 15px;
        font-weight: 400;
        line-height: 20px;
        white-space: nowrap;
      }
    }
  }

  .coupons-block {
    margin: 12px auto;
    background: #fefefe;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    overflow: visible;
    .coupon-item {
      padding: 16px;
      display: flex;
      align-items: center;
      border-radius: 8px;
      background: var(--Card-Card-3, #fefefe);
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
      .coupon-check {
        width: 16px;
        height: 16px;
        &.checked {
          background: var(--icon-check) top left / 100% 100% no-repeat;
        }
        &.not-checked {
          background: var(--icon-not-check) top left / 100% 100% no-repeat;
        }
      }
      .coupon-con {
        flex: 1;
        display: flex;
        align-items: center;
        padding: 0 5px;
        .coupon {
          width: 20px;
          margin: 0 4px;
        }
        .coupon-info {
          .info-main {
            color: var(--Fonts-Font-2, #666);
            font-family: 'Inter Tight';
            font-size: 15px;
            font-style: normal;
            line-height: 18px;
          }

          .info-tips {
            color: var(--Fonts-Font-3, #b2b2b2);
            font-family: 'Inter Tight';
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 14px;
          }
        }
      }
      .no-valid-coupon {
        .coupon-info {
          .info-main {
            color: var(--Fonts-Font-3, #b2b2b2);
          }
        }
      }
      .coupon-arrow {
        width: 16px;
        height: 16px;
        background: var(--icon-arrow) top left / 100% 100% no-repeat;
        transform: rotateZ(180deg);
        &.arrow-up {
          transform: rotateZ(0deg);
        }
      }
    }

    > .coupon-item {
      position: relative;
      z-index: 2;
    }

    .coupon-scroll {
      width: 100%;
      margin-top: 5px;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
      background-color: #ffffff;
      max-height: 270px;
      overflow-y: auto;
      .coupon-item {
        box-shadow: none;
        z-index: 2;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 16px;
          bottom: 0px;
          width: calc(100% - 32px);
          height: 0px;
          border-bottom: 0.5px solid var(--Divider-Divider1, #ededed);
        }
        &:last-child {
          &::after {
            border: 0;
          }
        }
      }
    }
  }

  .method-item {
    width: 100%;
    margin-top: 12px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid transparent;

    .method-tips {
      padding: 4px 10px;
      font-family: Outfit;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      text-align: center;
      color: #ffffff;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .method-con {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 16px;
      background: #ffffff;

      .method-check {
        width: 16px;
        height: 16px;
        &.checked {
          background: var(--icon-check) top left / 100% 100% no-repeat;
        }
        &.not-checked {
          background: var(--icon-not-check) top left / 100% 100% no-repeat;
        }
      }

      .method-img {
        display: flex;
        justify-content: center;
        width: 40px;
        > img {
          width: 30px;
          object-fit: contain;
        }
      }
      .method-name {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .method-info {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .name {
            color: var(--Fonts-Font-1, #333);
            font-family: 'Inter Tight';
            font-size: 15px;
            font-weight: bold;
            line-height: 18px;
          }
          .discount {
            padding: 2px 6px;
            margin-top: 2px;
            border-radius: 20px;
            background: var(--General-Red-All-2, #f00);

            color: var(--System-Color-White, #fff);
            font-family: 'Inter Tight';
            font-size: 10px;
            font-style: italic;
            font-weight: 700;
            line-height: 12px;
          }
        }

        .rate {
          color: #333333;
          font-family: 'Inter Tight';
          font-size: 15px;
          font-weight: bold;
          line-height: 18px;
          white-space: nowrap;
        }
      }
    }
  }
  .best-type {
    .method-tips {
      background: #a338fc;
    }
  }
  .method-on {
    border: 1px solid #a338fc;
  }

  .method-more {
    width: 100%;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    .trangle {
      box-sizing: content-box;
      width: 16px;
      height: 16px;
      border: 12px solid transparent;
      background: var(--icon-trangle) left top / 100% auto no-repeat;
    }
    .trangle-down {
      transform: rotateZ(180deg);
    }
  }

  .submit-btn-block {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(249, 249, 251, 0.8);
    padding-top: 20px;

    .submit-btn {
      width: 303px;
      margin: auto;
      padding: 13px 20px;
      border-radius: 100px;
      background: var(--Primary-Color-100, #a338fc);
      color: #fff;
      text-align: center;
      font-family: 'Inter Tight';
      font-size: 17px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 16px;
        margin: 0 3px;
      }
    }
  }
}

@keyframes slideLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: Inter-Bold, Inter;
  font-weight: bold;
  color: #333333;
}
::v-deep .coupon-enter {
  margin-bottom: 20px;
}

html[lang='ar'] {
  .container-pay .block-title div:nth-child(2) {
    text-align: left;
  }
}
</style>

<style>
.pay-coin-icon {
  width: 14px;
  height: 14px;
}
</style>
